<template>
  <m-dialog ref="dlg" :btnsave="false" :title="user && user.id ? '' : ''">
    <v-container grid-list-md class="pa-5">
      <v-row>
        <v-col cols="12">
          <m-card title="Detil Pengguna">
            <v-row wrap>
              <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pr-2 text-center">
                <v-card text color="#fff" flat>
                  <v-container fill-height container--fluid>
                    <v-row fill-height>
                      <v-col class="text-center" cols="12" align-end colbox>
                        <img
                          height="200"
                          src="https://cdn.siap.id/s3/asset illustrasi/Illustrasi/bg-default.png"
                          alt="avatar"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="12" sm="9" md="9" lg="9" xl="9">
                <v-list>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Nama</v-list-item-subtitle>
                          <div class="primary--text title">{{ pVal(detil, "name") }}</div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Surel</v-list-item-subtitle>
                          <div class="primary--text">{{ pVal(detil, "email") }}</div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                      <v-list-item>
                        <v-list-item-content>
                          <v-chip
                            width="100"
                            v-if="detil.is_angkatan1"
                            small
                            outlined
                            class="amber amber--text font-weight-bold justify-center ma-0 mt-2"
                            >Penyegaran (1 - 4 Juli 2020)</v-chip
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                <p class="black--text ml-3">Mata Pelajaran</p>
                <v-chip label color="secondary white--text" text class="ma-1" v-for="pk in detil.mapel" :key="pk.id">{{
                  pVal(pk, "keterangan")
                }}</v-chip>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                <v-data-table
                  :headers="headers"
                  :items="detil.perankelas"
                  :items-per-page="15"
                  item-key="id"
                  :hide-default-footer="true"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td>
                          <p class="subtitle-1 primary--text my-0 py-0">{{ pVal(item.grup, "keterangan") }}</p>
                        </td>
                        <td>
                          <p class="subtitle-1 primary--text my-0 py-0">{{ pVal(item.diklat, "nama") }}</p>
                        </td>
                        <td>
                          <p class="subtitle-1 primary--text my-0 py-0">{{ pVal(item.instansi, "nama") }}</p>
                        </td>
                        <td>
                          <p class="subtitle-1 primary--text my-0 py-0">{{ pVal(item.kelas, "nama") }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
                <br />
              </v-col>
            </v-row>
          </m-card>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  data() {
    return {
      user: {},
      detil: {},
      headers: [
        { text: "Peran", align: "left", value: "", sortable: false },
        { text: "Diklat", align: "left", value: "", sortable: false },
        { text: "Instansi", align: "left", value: "", sortable: false },
        { text: "Kelas", align: "left", value: "", sortable: false }
      ]
    };
  },
  methods: {
    open(obj) {
      this.user = { ...obj };
      this.loadDetil();
      let x = this.$refs.dlg.open();
      return x;
    },
    loadDetil() {
      return this.$store
        .dispatch("user/getDetilPenggunaDiklat", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          user_id: this.user.id
        })
        .then(res => {
          this.detil = res;
        })
        .catch(e => e);
    }
  }
};
</script>
